export default __webpack_public_path__ + "static/media/alphabet-yellow-q.e07e632a.png";